<template>
  <ra-summary-card label="Total Verification Requests" :value="totalRequests" />
</template>

<script>
import apiConstants from "@/apiConstants.js";
import "chartjs-plugin-datalabels";

export default {
  name: "VerificationsCount",
  data() {
    return {
      totalRequests: 0,
      noAccessCodes: apiConstants.NO_ACCESS_CODES
    };
  },

  mounted() {
    this.summaryStats();
  },

  methods: {
    summaryStats() {
      const apiUrl = "services/logs";
      const aggs = JSON.stringify([
        {
          field: "id",
          func: "count",
          alias: "total_count"
        }
      ]);
      const params = `aggs=${aggs}`;

      this.$http
        .post(
          apiUrl,
          {
            method: "GET",
            params: params
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.SERVICES
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            const total = resData.list.length && resData.list[0].total_count;
            this.totalRequests = total ? total : 0;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    }
  }
};
</script>

<style></style>
